import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Badge } from "../../../../../../components/badge/Badge";
import { useSignupContext } from "../../../../../../hooks/useSignupContext.shared";
import { OrderInfoCard } from "../../../../../order/OrderInforCard/OrderInfoCard";

export const StorefrontSignupDialogBasketInfo = ({
  supplier,
  className,
}: {
  supplier?: SupplierGetResponseType;
  className?: string;
}): ReactElement => {
  const { basketTotal } = useSignupContext();
  return (
    <OrderInfoCard
      businessName={supplier?.Business.name ?? ""}
      logoUrl={supplier?.Business.logoUrl ?? ""}
      className={className}
      total={basketTotal ?? 0}
      isNewCustomer={false}
    >
      <Badge
        icon={"PROGRESS_CLOCK"}
        className={"bg-yellow-100 font-medium text-yellow-800"}
      >
        Order pending
      </Badge>
    </OrderInfoCard>
  );
};
